import { render } from "./NewsletterSenderPreview.vue?vue&type=template&id=63f34b1b&scoped=true&ts=true"
import script from "./NewsletterSenderPreview.vue?vue&type=script&lang=ts"
export * from "./NewsletterSenderPreview.vue?vue&type=script&lang=ts"

import "./NewsletterSenderPreview.vue?vue&type=style&index=0&id=63f34b1b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f34b1b"]])

export default __exports__